import { Box } from "@material-ui/core";
import styled from "styled-components";
import Button from "../../../../components/Button";
import NovoSelect from "../../../../components/Inputs/Select";
import theme from "../../../../styles/defaultTheme";

export const SearchContainer = styled(Box)`
    gap: 20px;
    flex-wrap: wrap;

  & > div {
    flex: 2;

    &:first-child {
      flex: 1;
    }
  }

  @media screen and (max-width: 1260px) {
    & > * {
      width: 49%;
      flex: none !important;
    }

    button {
      margin-top: 8px !important;
    }
  }

  @media screen and (max-width: 840px) {
    & > * {
      width: 100%;
    }
  }
`;

export const ContainerRadio = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SearchButton = styled(Button)`
    height: 44px;
    margin-top: 32px;
    position: relative;
    right: 400px;
`;

export const StyledSelect = styled(NovoSelect)`
    width: 100%;
`;

export const CellWithIcon = styled.div`
    display: flex;
    gap: 0 5.5px;
    align-items: center;

    & span[class*="material-icons"] {
        cursor: pointer;
    }
`;

export const TooltipText = styled.div`
    font: ${theme.font.body[2]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.grey};
`;


export const TableContainer = styled.div`
    margin: 0;
`;

export const LinkButtonRegister = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 5px;
    margin-bottom: 8px;
    margin-top: 8px;
    margin-left: 200px;
    width: 80%;
    cursor: pointer;

    span {
        font-size: ${theme.font.size16};
        font-weight: bold;
        text-decoration: underline;
        color: ${(props) => props.theme.disabledGrey};
        cursor: not-allowed;
        width: max-content;

        &.active {
            color: ${(props) => props.theme.orangeLink};
            cursor: pointer;
        }
    }
`;

export const Texto = styled.div`
    position: relative;
    margin: 5px;
`;
